import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import Home from './components/home/Home';
import Universe from './components/universe/Universe';
import StockDetail from './components/universe/StockDetail';
import IndicatorCharts from './components/universe/IndicatorCharts';
import MainDashboard from './components/MainDashboard';
import Login from './components/Login';
import RequireAuth from './components/RequireAuth';
import { AuthProvider } from './context/AuthContext';
import { theme } from './design/theme';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<RequireAuth><Home /></RequireAuth>} />
            <Route path="/universe" element={<RequireAuth><Universe /></RequireAuth>} />
            <Route path="/universe/:ticker" element={<RequireAuth><StockDetail /></RequireAuth>} />
            <Route path="/universe/:ticker/indicators" element={<RequireAuth><IndicatorCharts /></RequireAuth>} />
            <Route path="/trader/:traderId" element={<RequireAuth><MainDashboard /></RequireAuth>} />
            <Route path="/trader/:traderId/:tab" element={<RequireAuth><MainDashboard /></RequireAuth>} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App; 